import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AzureEnvironment } from '../types/azureEnvironment';

interface AzureEnvironmentState {
  environment: AzureEnvironment | null;
}

const initialState: AzureEnvironmentState = {
  environment: null,
};

const azureEnvironmentSlice = createSlice({
  name: 'azureEnvironment',
  initialState,
  reducers: {
    setAzureEnvironment: (state, action: PayloadAction<AzureEnvironment>) => {
      return {
        ...state,
        environment: action.payload,
      };
    },
    clearAzureEnvironment: (state) => {
      return {
        ...state,
        environment: null,
      };
    },
  },
});

export const { setAzureEnvironment, clearAzureEnvironment } = azureEnvironmentSlice.actions;
export default azureEnvironmentSlice.reducer;
